import { FC } from 'react';
import { Row, Col, Space, Form, Table, Tooltip } from 'antd';
import { ColumnType } from 'antd/lib/table';
import { FormInstance } from 'antd/es/form/Form';
import Paper from 'components/atoms/Paper';
import LinkButton from 'components/atoms/Button/LinkButton';
import DefaultButton from 'components/atoms/Button/DefaultButton';
import { AccessDeviceEditTableModel } from './AccessColumn';
import './styles.scss';

interface AccessProps {
  devices: AccessDeviceEditTableModel[];
  accessColumn: ColumnType<AccessDeviceEditTableModel>[];
  form: FormInstance<any>;
  title: string;
  createInvitationButtonText: string;
  createInvitationInfoText: string;
  listInvitationsButtonText: string;
  listInvitationsInfoText: string;
  assignRoomButtonText: string;
  updateButtonText: string;
  onOpenCreateInvitation: () => void;
  onOpenInvitationsListModal: () => void;
  onClickAssignRoom: () => void;
  onRefresh: () => void;
  loading: boolean;
  isCreateAndListInvitationsForbidden: boolean;
  isAssignRoomButtonVisible: boolean;
}

const Access: FC<AccessProps> = ({
  devices,
  accessColumn,
  form,
  title,
  createInvitationButtonText,
  createInvitationInfoText,
  listInvitationsButtonText,
  listInvitationsInfoText,
  assignRoomButtonText,
  updateButtonText,
  onOpenCreateInvitation,
  onOpenInvitationsListModal,
  onClickAssignRoom,
  onRefresh,
  loading,
  isCreateAndListInvitationsForbidden,
  isAssignRoomButtonVisible,
}) => {

  return (
    <Paper>
      <div className={'Access__contextual-menu'}>
        <h2>{title}</h2>
      </div>
      {!isCreateAndListInvitationsForbidden && (
        <Row justify={'start'} align={'top'} className='TabUsers__headers'>
          <Col className={'Access__buttons'}>
            <Space>
              <Tooltip placement={'top'} title={createInvitationInfoText}>
                <DefaultButton onClick={onOpenCreateInvitation} title={createInvitationButtonText} />
              </Tooltip>
              <Tooltip placement={'top'} title={listInvitationsInfoText}>
                <DefaultButton onClick={onOpenInvitationsListModal} title={listInvitationsButtonText} />
              </Tooltip>
            </Space>
            {isAssignRoomButtonVisible && (
              <Space>
                <DefaultButton onClick={onClickAssignRoom} title={assignRoomButtonText} />
                <LinkButton onClick={onRefresh} title={updateButtonText} />
              </Space>
            )}
          </Col>
        </Row>
      )}
      <Form form={form} component={false}>
        <Table<AccessDeviceEditTableModel>
          size={'middle'}
          key={devices.length}
          loading={loading}
          columns={accessColumn}
          rowKey={'deviceName'}
          dataSource={devices}
          pagination={false}
        />
      </Form>
    </Paper>
  );
};

export default Access;
